import { Component, ViewChild, Input, ChangeDetectionStrategy } from "@angular/core";
import { DocumentService } from "../../viewer-components/services/internal-services/document.service";
import { ViewerConstants } from "../../shared/model/viewer-constants";

import { MatTooltip, TooltipPosition } from "@angular/material/tooltip";

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: "app-copy-clipboard",
  templateUrl: "./copy-clipboard.component.html",
  styleUrls: ["./copy-clipboard.component.scss"],
  standalone: false,
})
export class CopyClipboardComponent {
  @Input("message") message: string;

  @Input("buttonText") buttonText: string;

  @Input("disable") disable: boolean;

  @Input("tooltipPosition") position: TooltipPosition;

  @Input("value") value: any;

  @Input("type") type: "icon" | "basic" | "icon-text" = "icon";

  @Input("customClass") customClass: string = "";

  @Input("hoverTooltip") hoverTooltip: string = "";

  @ViewChild("tooltip") tooltip: MatTooltip;

  content_copy = ViewerConstants.CONTENT_COPY;

  copyToClipboard() {
    DocumentService.copyTextToClipboard(this.value);
    if (this.hoverTooltip) {
      this.tooltip.message = this.message;
      this.tooltip.show();
      setTimeout(() => {
        this.tooltip.message = this.hoverTooltip;
        this.tooltip.hide();
      }, 2000);
    } else {
      this.tooltip.disabled = false;
      this.tooltip.show();
      setTimeout(() => {
        this.tooltip.hide();
        this.tooltip.disabled = true;
      }, 2000);
    }
  }
}
